import { useAuthStore } from '@/stores/authStore';
import { isFixedTierRole } from '@/themes/roleTier';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { DashboardThemeSlot } from '@/themes/DashboardThemeSlot';
import CreatePropertyPage from '@/pages/dashboard/CreatePropertyPage';
import CreateExperiencePage from '@/pages/dashboard/CreateExperiencePage';

export type CreatePageKind = 'property' | 'experience';

/**
 * `/dashboard/properties/new` and `/dashboard/experiences/new` need to work for fixed-tier roles
 * (Super Admin/Platform Admin/Platform Staff) creating on behalf of an org, but `DashboardThemeSlot`
 * renders null for those roles (ADR-2026-07-D -- they never touch themed components), which left
 * these two routes blank for them. These slots render the plain shared page directly under the
 * fixed-tier `DashboardLayout` shell for those roles, and fall through to the normal themed flow
 * for everyone else.
 */
export function CreatePageShellSlot() {
  const { user } = useAuthStore();
  const role = user?.roles?.[0];

  if (isFixedTierRole(role)) {
    return <DashboardLayout />;
  }
  return <DashboardThemeSlot page="DashboardShell" />;
}

export function CreatePageSlot({ page }: { page: CreatePageKind }) {
  const { user } = useAuthStore();
  const role = user?.roles?.[0];

  if (isFixedTierRole(role)) {
    return page === 'property' ? <CreatePropertyPage /> : <CreateExperiencePage />;
  }
  return <DashboardThemeSlot page={page === 'property' ? 'PropertyCreateEditPage' : 'ExperienceCreatePage'} />;
}
